import { render, staticRenderFns } from "./adjust-game-sys.vue?vue&type=template&id=2fbe861e&lang=pug"
import script from "./adjust-game-sys.vue?vue&type=script&lang=js"
export * from "./adjust-game-sys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports